import { Component, OnInit } from '@angular/core';
import { PartnerPrivilege } from '../../../../enum/landing-enum';

@Component({
  selector: 'flowaccount-perk-for-partner',
  templateUrl: './perk-for-partner.component.html',
  styleUrls: ['./perk-for-partner.component.scss']
})
export class PerkForPartnerComponent implements OnInit {
  tab = 1
  creditCardLogo: { visa: string; mastercard: string; JCB: string; promptpay: string; };

  PartnerPrivilegeEnum = PartnerPrivilege

  public currentSlide = 1

  public imageAlt = ''

  ngOnInit(): void {
    this.creditCardLogo = {
      visa: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/visa-logo.png" width="auto" height="20" alt="visa-logo">',
      mastercard: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/master-card-logo.png" width="auto" height="20" alt="visa-logo">',
      JCB: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/jcb-logo.png" width="auto" height="20" alt="visa-logo">',
      promptpay: '<img class="mt-minus-5" src="https://flowaccountcdn.com/images/payment/Promptpay.png" width="auto" height="20" alt="visa-logo">'
    }
    this.displayImageAltByTab()
  }

  onClickTab(no: number) {
    this.displayImageAltByTab()
    return this.tab = no
  }

  loopArray(no: number) {
    return new Array(no)
  }

  actionClickSlide(actionName: string) {
    const slide = this.currentSlide
    const lastTab = 4
    if (actionName === 'prev') {
      if (slide === 1) {
        this.currentSlide = lastTab
      } else {
        this.currentSlide -= 1
      }
    } else if (actionName === 'next') {
      if (slide === lastTab) {
        this.currentSlide = 1
      } else {
        this.currentSlide += 1
      }
    }

    this.showDynamicContentForMobile()
  }

  showDynamicContentForMobile() {
    switch (this.currentSlide) {
      case 1:
        this.tab = this.PartnerPrivilegeEnum.PROMOTE
        break;
      case 2:
        this.tab = this.PartnerPrivilegeEnum.SPECIAL_TAKE_CARE
        break;
      case 3:
        this.tab = this.PartnerPrivilegeEnum.BE_PART_OF_TEAM
        break;
      case 4:
        this.tab = this.PartnerPrivilegeEnum.SPECIAL_PRIZE
        break;
    }
    this.displayImageAltByTab()
  }

  displayImageAltByTab() {
    switch (this.tab) {
      case 1:
        return this.imageAlt = 'โปรแกรมบัญชีฟรี'
      case 2:
        return this.imageAlt = 'โล่ห์รางวัล'
      case 3:
        return this.imageAlt = 'ติดต่อซัพพอร์ต FlowAccount'
      case 4:
        return this.imageAlt = 'สำนักงานบัญชีพาร์ตเนอร์ FlowAccount'
    }
  }


}
